<template>
    <div class="main-block request-management">
         <Breadcrumbs />
        <div class="div col-12 p-0 d-flex align-items-start">
            <h4 class="">{{ $t('title.SalesforceFinancialServicesCloudUsers') }}</h4>
        </div>
        <div class="scrollable-block">
            <div class="col-12 row mt-3 m-0 p-0" style="min-height: 90%">
                <crud-table :columns="columns" :list-url="listUrl" ref="application-table" v-on:refresh="resetFilter">
                    <template slot>
                        <!-- <b-button variant="primary" @click="processSelectedUsers">
                <b-icon icon="check-square" class="icon-style"></b-icon>
              </b-button> -->
                        <b-button variant="primary" @click="$router.go(-1)">
                            <b-icon icon="arrow-left" class="icon-style"></b-icon>
                        </b-button>
                    </template>

                    <template #cell(actions)="{ item }">
                        <!-- Checkbox for selecting users -->
                        <input type="checkbox" :value="item.microsoft_user_id" v-model="selectedUsers" class="mr-2" />

                        <b-button variant="light" class="ml-2"
                            @click="$router.push({ name: 'Inbox', params: { id: item.microsoft_user_id } })">
                            <b-icon variant="primary" icon="envelope" class="icon-style"></b-icon>
                        </b-button>
                    </template>

                    <!-- Display Response Payload -->
                    <template #cell(response_payload)="{ item }">
                        <div>
                            <div v-for="(value, key) in item.response_payload" :key="key"
                                class="d-flex justify-content-between align-items-center">
                                <span>
                                    <strong>{{ key }}</strong> :-{{ value }}
                                </span>
                            </div>
                        </div>
                    </template>

                    <!-- Display Created At Time -->
                    <template #cell(created_at)="{ item }">
                        <div>
                            <span>
                                {{ formatDate(item.created_at) }}
                            </span>
                        </div>
                    </template>

                    <!-- Custom cell for billing_address -->
                    <template #cell(billing_address)="{ item }">
                        <div>
                            <!-- Attempt to parse billing_address JSON -->
                            <pre>{{ parseAndFormatJSON(item.billing_address) }}</pre>
                        </div>
                    </template>

                    <!-- Custom cell for shipping_address -->
                    <template #cell(shipping_address)="{ item }">
                        <div>
                            <!-- Attempt to parse shipping_address JSON -->
                            <pre>{{ parseAndFormatJSON(item.shipping_address) }}</pre>
                        </div>
                    </template>

                </crud-table>
            </div>
        </div>
    </div>
</template>

<script>
import { request } from "@/Util/Request";
import { Modal } from "bootstrap";
import Breadcrumbs from "@/components/Breadcrumbs.vue";

const FILTER_FORM = {
    roles: null,
    statuses: null,
    integration_id: null
};

const COLUMN_STATE = (self) => [
    { key: 'actions', label: self.$t('title.actions') },
    { key: 'financial_account_id', label: self.$t('title.financial_account_id'), sortable: true },
    { key: 'name', label: self.$t('title.name'), sortable: true },
    { key: 'financial_account_number', label: self.$t('title.financial_account_number'), sortable: true },
    { key: 'source_system_identifier', label: self.$t('title.source_system_identifier'), sortable: true },
    { key: 'type', label: self.$t('title.type'), sortable: true },
    { key: 'product_id', label: self.$t('title.product_id'), sortable: true },
    { key: 'branch_unit_id', label: self.$t('title.branch_unit_id'), sortable: true },
    { key: 'banker_id', label: self.$t('title.banker_id'), sortable: true },
    { key: 'credit_limit', label: self.$t('title.credit_limit'), sortable: true },
    { key: 'owner_id', label: self.$t('title.owner_id'), sortable: true },
    { key: 'status', label: self.$t('title.status'), sortable: true }
];


export default {
    data() {
        return {
            selectedUsers: [], // Store selected Microsoft User IDs
            filters: { ...FILTER_FORM },
        };
    },
    components: { Breadcrumbs },
    mounted() {
        if(this.$route.query.id) {
            this.$refs['application-table'].handleCustomSearch(this.$route.query.id);
        }
    },
    methods: {
        resetFilter() {
            this.filters = { ...FILTER_FORM };
            this.$refs['application-table'].handleFilter({ filters: this.filters });
        },
        formatDate(dateString) {
            return new Date(dateString).toLocaleString();
        },

        parseAndFormatJSON(jsonString) {
            try {
                const obj = typeof jsonString === 'object' ? jsonString : JSON.parse(jsonString);
                // Format the JSON object for display.
                // You can customize this further to output a more formatted view.
                return JSON.stringify(obj, null, 2);
            } catch (error) {
                // In case of error, return the original string.
                return jsonString;
            }
        }
    },
    computed: {
        listUrl() {
            const id = this.$route.params.id || '';
            return `admin/salesforce/financial-services-cloud-accounts/${id}`;
        },
        columns() {
            return COLUMN_STATE(this);
        }
    }
};
</script>